/* istanbul ignore file */
import axios from "axios";
import { SAVE_LOAN, SAVE_LOAN_ID, SAVE_LOAN_IN_STATUS, SAVE_WITHDRAW_LOAN_STATUS } from "../../Redux/types";
import { API_ENDPOINT } from "../../apiConstant";

export const saveLoanId = (id) => {
  return (dispatch) => {
    dispatch({
      type: SAVE_LOAN_ID,
      payload: id,
    });
  };
};

export const saveLoanDetails = (dispatch, data) =>
  dispatch({
    type: SAVE_LOAN,
    payload: data,
  });

export const saveLoanStatusInDetail = (dispatch, data) =>
  dispatch({
    type: SAVE_LOAN_IN_STATUS,
    payload: data,
  });

  export const saveWithdrawLoanDetail = (dispatch, data) =>
  dispatch({
    type: SAVE_WITHDRAW_LOAN_STATUS,
    payload: data,
  });

export const getRepaymentDate = (loan_type, token) => {
  let url = `${API_ENDPOINT}/api/loan/repayment_date/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  let data = {
    loan_type: loan_type,
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const savePayment = (token, data) => {
  let url = `${API_ENDPOINT}/api/gpay_payment_update/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          // console.log("res redux", res);
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const applyForLoan = (token, data) => {
  let url = `${API_ENDPOINT}/api/loan/loan_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const loanHistoryApi = (token) => {
  let url = `${API_ENDPOINT}/api/loan/loan_history/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          saveLoanDetails(dispatch, res.data);
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const loan_repayment = (token) => {
  let url = `${API_ENDPOINT}/api/loan/loan_repayment/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          saveLoanDetails(dispatch, res.data);
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const loanStatusApi = (data, token) => {
  let url = `${API_ENDPOINT}/api/loan/loan_details_get/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          saveLoanStatusInDetail(dispatch, res?.data);
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const submitFeedbackApi = (data, token) => {
  let url = `${API_ENDPOINT}/api/feedback/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


export const getWithdrawDetails = (token) => {
  let url = `${API_ENDPOINT}/api/loan/withdraw_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          saveWithdrawLoanDetail(dispatch, res?.data);
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};
export const getForClosureDetails = (token) => {
  let url = `${API_ENDPOINT}/api/loan/foreclosure_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          saveWithdrawLoanDetail(dispatch, res?.data);
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


export const eSignWebView = (token, params) => {
  // alert(params)
  let url = `${API_ENDPOINT}/api/v4/webview_url/esign/?is_insurance=${params}`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
};


export const chatbotWebView = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/chatbot/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
};

export const chatbotTicketView = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/chatbot_tickets/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
};


export const eMandateWebView = (token) => {
  let url = `${API_ENDPOINT}/api/webview_url/emandate/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const dashboardLoanStatusApi = (token) => {
  let url = `${API_ENDPOINT}/api/loan/loan_details_get/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, {}, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getPromoList = (token) => {
  let url = `${API_ENDPOINT}/api/promotion_code_list/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};

export const postVoucherCheck = (token, data) => {
  let url = `${API_ENDPOINT}/api/voucher_check/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getPromotionList = (token) => {
  let url = `${API_ENDPOINT}/api/promotion_list/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};

export const getNotification = (token) => {
  let url = `${API_ENDPOINT}/api/notification/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};

export const postNotification = (token, data) => {
  let url = `${API_ENDPOINT}/api/notification/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};

export const rewardPoint = (token) => {
  let url = `${API_ENDPOINT}/api/reward/reward_points/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};
export const KeyFactStatements = (data, token) => {
  let url = `${API_ENDPOINT}/api/user_details/key_fact_doc/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res.data);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};

export const profilePicture = (data, token) => {
  let url = `${API_ENDPOINT}/api/presigned_url_user_image/`;

  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })

        .catch((err) => {
          return reject(err);
        });
    });
};

export const nbfcDetails = (token) => {
  let url = `${API_ENDPOINT}/api/loan/nbfc_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const download_nach_form = (token) => {
  let url = `${API_ENDPOINT}/api/download_nach_form/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};
export const getLoanData = (data, token) => {
  let url = `${API_ENDPOINT}/api/transaction/repayment_amount/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};
export const getRepaymentAmount = (data, token) => {
  let url = `${API_ENDPOINT}/api/transaction/repayment_amount/?cal_for=${data}`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getWithdrawLoanData = (data, token) => {
  let url = `${API_ENDPOINT}/api/transaction/repayment_amount/?calc_for=${data}`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};




export const getReasonForLoan = (token) => {
  let url = `${API_ENDPOINT}/api/reason_for_loan/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};
export const create_ckyc = (data, token) => {
  let url = `${API_ENDPOINT}/api/v2/create_ckyc/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data , config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getNoc = (data, token) => {
  let url = `${API_ENDPOINT}/api/loan/send_noc/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getBank = (token) => {
  let url = `${API_ENDPOINT}/api/bank_list_fetch_statement/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            return reject(error.response.status);
          }
        });
    });
};

export const getLink = (token) => {
  let url = `${API_ENDPOINT}/api/sahamati_link/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            return reject(error.response.status);
          }
        });
    });
};
export const phoneNumberVerify = (data) => {
  let url = `${API_ENDPOINT}/api/v2/authentication/phone_no_verify/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getLoanCalculation = (data, token) => {
  let url = `${API_ENDPOINT}/api/loan/calculation/`;
  
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          headers: {
            Authorization: "Token " + token,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


export const notifyVisitorEvent = (payload ) => {
  
  const url = "https://ri.paymeindia.in/api/notify/event_send/";
  let token = localStorage.getItem("gpay_token");
  
  const config = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Token " + token,
    },
  };

  return new Promise((resolve, reject) => {
    axios
      .post(url, payload, config)
      .then((response) => {
        console.log("Event successfully sent:", response);
        resolve(response);
      })
      .catch((error) => {
        if (error.response) {
          console.error("API Error:", error.response.status, error.response.data);
          reject(error.response);
        } else if (error.request) {
          console.error("No response received:", error.request);
          reject(error.request);
        } else {
          console.error("Error in setup:", error.message);
          reject(error.message);
        }
      });
  });
};

const headersApplicationJson = {
  "Content-Type": "application/json",
};

export const applyForLoan1 = (data) => {
  let url = `${API_ENDPOINT}/api/loan/loan_details/`;
  let config = {
    headers: headersApplicationJson,
  };
  return  new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

